import React, { useEffect, useState } from 'react';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Col, Input, Modal, Row, Select, Table, Tooltip } from 'antd';
import Title from 'antd/es/typography/Title';
import * as _ from 'lodash';
import { columnsResultComplete } from './config';
import { getResultConfirmComplete } from '../category-evaluation.reducer';
import { filterOption } from 'app/shared/util/select-filter';
import { setFilterResultComplete } from 'app/entities/filters/filters.reducer';
import { PlantPeriodType } from 'app/shared/model/enum/plantPeriod.enum';
import { getEntities as getPlanPeriods } from 'app/entities/plan-period/plan-period.reducer';
import EvaConfirmCompleteEvaluation from './evaluate/confirm-complete';

type IResultCompleteProps = {
    isOpen: boolean;
    onClose: () => void;
};

const { Search } = Input;
export const ResultCompleteComponent = React.memo(({ isOpen, onClose }: IResultCompleteProps) => {
    const dispatch = useAppDispatch();
    const loading = useAppSelector(state => state.categoryEvaluation.loading);
    const account = useAppSelector(state => state.authentication.account);
    const filters = useAppSelector(state => state.filters.resultComplete);
    const planPeriodList = useAppSelector(state => state.planPeriod.entities);
    const entities = useAppSelector(state => state.categoryEvaluation.resultEvaluations);

    // init state variables
    const [isOpenModalResultEvaluate, setOpenModalResultEvaluate] = useState(null);

    const columnsConfig = columnsResultComplete.concat(
        [
            {
                title: `Năm ${filters?.year - 1}`,
                key: 'preYearRank',
                align: 'center',
                dataIndex: 'preYearRank',
            },
            {
                title: `Năm ${filters?.year}`,
                key: 'detailCurrentYearRank',
                align: 'center',
                dataIndex: 'detailCurrentYearRank',
            },
            {
                title: 'Hành động',
                key: 'action',
                width: 100,
                render(item: any) {
                    if (item.ownerId)
                        return (
                            <div className="action">
                                <span className="action-view">
                                    <Tooltip title="Xem chi tiết">
                                        <FontAwesomeIcon
                                            icon="eye"
                                            onClick={() => { handleOpenModalResultEvaluate(item) }}
                                        />
                                    </Tooltip>
                                </span>
                            </div>
                        )
                }
            }
        ])

    useEffect(() => {
        dispatch(getPlanPeriods({}));
    }, [])

    useEffect(() => {
        if (planPeriodList.length > 0 && !filters?.planPeriodId)
            handleChangePlanPeriod(planPeriodList[0].id);
    }, [planPeriodList, filters])

    useEffect(() => {
        if (filters?.planPeriodId)
            handleResultComplete();
    }, [filters.planPeriodId, filters?.searchText])


    const handleResultComplete = () => {
        dispatch(getResultConfirmComplete({ userId: account?.id, planPeriodId: filters?.planPeriodId, searchText: filters?.searchText }))
    }

    const handleClose = () => {
        onClose();
    };

    const handleFreeTextSearchQuery = query => {
        dispatch(setFilterResultComplete({ ...filters, searchText: query }))
    };

    const handleChangePlanPeriod = (value: string) => {
        const detailPlanPeriod = _.find(planPeriodList, o => o.id === value);
        if (detailPlanPeriod) {
            dispatch(
                setFilterResultComplete({
                    ...filters,
                    planPeriodId: value,
                    year: detailPlanPeriod.year,
                }),
            );
        }
    }

    const handleOpenModalResultEvaluate = (record: any) => {
        // TODO: open modal result evaluate
        setOpenModalResultEvaluate(true);
        dispatch(setFilterResultComplete({ ...filters, accountTableId: record?.ownerId, accountTableName: record?.ownerName }))
    }

    const handleCloseModalResultEvaluate = () => {
        setOpenModalResultEvaluate(false);
    }

    return (
        <Modal open={isOpen} maskClosable={false} footer={null} onCancel={handleClose} width={'80vw'} className='view'>
            <div className="d-flex gap-5">
                <Title level={3}>Kết quả đánh giá</Title>
            </div>
            <div className="header">
                <Col md={18}>
                    <Row className='w-100'>
                        <Col md={3}>
                            <Select
                                className="w-100"
                                value={filters?.planPeriodId}
                                showSearch
                                options={_.filter(planPeriodList, o => {
                                    return o.planPeriodType === PlantPeriodType.Year;
                                }).map(x => {
                                    return {
                                        label: x.name,
                                        value: x.id,
                                    };
                                })}
                                onChange={handleChangePlanPeriod}
                                filterOption={filterOption}
                                placeholder="Chọn kỳ kế hoạch"
                                size="large"
                            />
                        </Col>
                        <Col md={1} />
                        <Col md={18}>
                            <Search size="large" allowClear placeholder="Nhập giá trị tìm kiếm" onSearch={handleFreeTextSearchQuery} enterButton />
                        </Col>
                    </Row>
                </Col>
            </div>
            <div className="table">
                <Table scroll={{ y: '60vh' }} loading={loading} bordered dataSource={entities?.map((x: any, index) => {
                    return {
                        ...x,
                        key: index,
                        children: x.children?.map(y => ({ ...y, key: y.itemId }))
                    }
                })} pagination={false} columns={columnsConfig} />
            </div>
            {isOpenModalResultEvaluate &&
                <EvaConfirmCompleteEvaluation
                    planPeriodId={filters?.planPeriodId}
                    accountTableId={filters?.accountTableId}
                    accountTableName={filters?.accountTableName}
                    isOpen={isOpenModalResultEvaluate}
                    onClose={handleCloseModalResultEvaluate}
                    isReadOnly={true} />
            }
        </Modal>
    );
});

export default ResultCompleteComponent;
